import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import getters from '@/vuex/getters'
import mutations from '@/vuex/mutations'
import actions from '@/vuex/actions'
import modules from '@/vuex/modules'
import util from '@/util'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isPreview: false,
    presentations: [] as any[],
    folders: [] as any[],
    currentUser: {},
    workingMode: util.getWorkingMode(), // personal || team
    currentAccount: {
    },
    isSyncing: 2,
    presentation: {
      slides: [] as any[],
      isShowingSlideSearch: false,
    },
    slideActive: {},
    activeModelDetailSlide: false,
    isNewPresentation: true,
    currentSlideMode: '',
    currentSlideCanvas: '',
    socketDisconnect: false,
    isQRCodeVisible: false,
    showExport: false,
    sharePresentation: false,
    audiences: {},
    continueQuiz: false,
    userOnline: 0,
    onlineStatus: 1,
    plan: {},
    countPlayer: 0,
    showQnaSession: false,
    questions: [] as any[],
    tabQnaQuestion: 1,
    lastQuestion: {},
    questionCount: 0,
    countTopQuestion: 0,
    countPinnedQuestion: 0,
    countAnswerQuestion: 0,
    showLiveAudienceDemo: false,
    isTouchScreen: false,
    importStatus: 1,
    importError: '',
    openImportModal: false,
    quizConfirmation: false,
    quizConfirmationType: null,
    historyKeyboard: null,
    socketId: null,
    tempAudienceCount: 0,
    isAdmin: false,
    transitionContent: '',
    isPresenterWhiteLabel: true,
    // support export pdf capture slide on presentation sharing. url has params capture=true
    isScreenCapture: false,
    hasNews: false,
    isUploadImageInProcess: false,
    requestedApplyConfigsToAll: false,

    // ids
    activeSlideId: null,

    // loaders
    loaders: {
      morePresentationsLoading: false,
    },

    // numbers
    numbers: {
      numberOfPresentationPages: 1,
      numberOfLoadedPresentationPages: 1,
    },

    // indicators
    isTokenValid: true,

    indicators: {
      isServerConnectable: true,
      isWelcomePopupShowing: false,
      hasOnboardingV3: false,
      isOnboardingV3Showing: false,
      isRouterViewContentShowing: false,
      isHomeSideBarShowing: false,
      showingSlideGrid: false,
    },

    // errors
    errors: {
      errorOnInternalServer: null,
    },

    // selections
    selections: {
      selectedTab: 'upload',
      selectedFolderId: null,
      selectedSlideIds: [] as any[],
      selectedSortCriteria: {
        sortColumn: 'updatedAt',
        sortOrder: 'desc',
      },
    },
    presentIsBeginning: false,
    presentIsExtraButton: false,
    slideTypePreview: {},
    presentationEditors: [] as any[],
    isDisableEditPresentation: false,
    isComeFromSignupPage: false, // check audience come from signup page
    isPlayDemoMode: false,
    isCreatingNewPresentation: false, // for loading screen when creating new presentation
    search: {
      searchBy: 'template', // global merge search
      totalTemplates: 0,
      totalPresentations: 0,
    },
    undoHistory: [],
    redoHistory: [],
    dataEventBusHistory: {},
    isBlockHistory: false,
    mapLockAddHistory: {},
    isLockAddHistory: 0,
    arrKeyLockAddHistory: [],
    allCanvasBlocks: {},
    isReferPublicTemplate: false,
    voiceCall: {},
    openModalImportSheet: false, // open modal import sheet file
    isRightClickInfoBoxVisible: true,
    mapAudienceIdWinnerRemoved: {},
    clipboardBlocks: null,
    clipboardSlideId: null,
    selectingBlocks: [],
    isAudioPlayingBeforeSlideSpinner: false,
    isMSTeamsApp: false,
    isDisableEditSlide: false,
    userEditingSlide: null,
    userInactiveReload: false,
    userOnlineByPresentationId: [],
  },
  getters,
  mutations,
  actions,
  modules,
})

export type State = typeof store.state

export type TMapState = Partial<Record<
  keyof State,
  (state: State) => State[keyof State]
>>

export interface InjectionKey<T> extends Symbol {}

export const key: InjectionKey<Store<State>> = Symbol('Vuex')

export default store
